import { Box, BoxProps, Heading } from "@chakra-ui/react";
import { ReactNode } from "react";

/**
 * One section of the cabinet API page: a surface card with an H2. Elevation
 * is the surface step plus a 1px border, which also reads in dark mode
 * (docs/design/ux-principles.md, Dark Mode).
 */
const Panel = ({
  id,
  title,
  children,
  ...rest
}: { id: string; title: ReactNode; children: ReactNode } & BoxProps) => (
  <Box
    as="section"
    aria-labelledby={`${id}-heading`}
    bg="bg.surface"
    borderWidth="1px"
    borderColor="border.subtle"
    borderRadius="lg"
    p={{ base: 4, md: 6 }}
    {...rest}
  >
    <Heading
      as="h2"
      id={`${id}-heading`}
      fontSize="xl"
      fontWeight="semibold"
      color="text.primary"
      mb={3}
    >
      {title}
    </Heading>
    {children}
  </Box>
);

export default Panel;
